import Header from './Headers';
import Const from '../util/Constants';
import Config from '../config/config';

class ModelAPI {

  static getModel = (success, failure) => {
    fetch(Config.app.link + 'api/model', new Header('GET'))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static getCountries = (success, failure) => {
    fetch(Config.app.link + 'api/country', new Header('GET'))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static getStates = (success, failure) => {
    fetch(Config.app.link + 'api/state', new Header('GET'))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static getCities = (success, failure) => {
    fetch(Config.app.link + 'api/city', new Header('GET'))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static getAreas = (success, failure, logout) => {
    fetch(Config.app.link + 'api/area', new Header('GET'))
    .then(res => Const.ProcessAPI(res, success, failure, logout))
    .catch(er => failure(er));
  }
}

export default ModelAPI;